const organizationEntity = {
  C_CORP: 'C_CORP',
  S_CORP: 'S_CORP',
  PARTNERSHIP: 'PARTNERSHIP',
  TRUST_ESTATE: 'TRUST_ESTATE',
  INDIVIDUAL: 'INDIVIDUAL',
  SOLE_PROPRIETORSHIP: 'SOLE_PROPRIETORSHIP',
  LIMITED_LIABILITY_COMPANY: 'LIMITED_LIABILITY_COMPANY',
  SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY: 'SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY',
};

const soleTraderEntityType = {
  entityType: 'SOLE_TRADER',
};

const partnershipEntityType = {
  entityType: 'PARTNERSHIP',
};

const publicListedCompanyEntityType = {
  entityType: 'PUBLIC_LISTED_COMPANY',
};

const privateCompanyEntityType = {
  entityType: 'PRIVATE_COMPANY',
};

const cCorpOrgEntityType = {
  entityType: organizationEntity.C_CORP,
  organizationEntityType: organizationEntity.C_CORP,
};

const solePropOrgEntityType = {
  entityType: organizationEntity.SOLE_PROPRIETORSHIP,
  organizationEntityType: organizationEntity.SOLE_PROPRIETORSHIP,
};

const partnershipOrgEntityType = {
  entityType: organizationEntity.PARTNERSHIP,
  organizationEntityType: organizationEntity.PARTNERSHIP,
};

export function entityTypeStepConfig({ country }) {
  return {
    soleTraderEntityType: {
      value: soleTraderEntityType,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    partnershipEntityType: {
      value: partnershipEntityType,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    publicListedCompanyEntityType: {
      value: publicListedCompanyEntityType,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    privateCompanyEntityType: {
      value: privateCompanyEntityType,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    organizationEntityType: {
      value: cCorpOrgEntityType,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    organizationEntityTypeSoleProp: {
      value: solePropOrgEntityType,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
    organizationEntityTypePartnership: {
      value: partnershipOrgEntityType,
      method: 'spreadProperty',
      path: 'businessDetails',
    },
  };
}
